// UI chrome for the public "Events & Neuigkeiten" page (5 languages).
export const eventsI18n = {
  de: {
    navLabel: "Neuigkeiten",
    eyebrow: "Events & Neuigkeiten",
    title: "Was bei Mara gerade passiert",
    lead: "Flohmärkte, Versteigerungen, Aktionen und Neuigkeiten aus unserem Café & Ausstellungsraum in Basel.",
    all: "Alle",
    upcoming: "Aktuelles",
    archive: "Archiv",
    readMore: "Mehr erfahren",
    back: "Zurück zur Übersicht",
    empty: "Zurzeit sind hier keine Beiträge vorhanden. Schauen Sie bald wieder vorbei.",
    when: "Wann",
    where: "Wo",
    archived: "Vergangen",
    detailBack: "Alle Beiträge",
  },
  en: {
    navLabel: "News",
    eyebrow: "Events & News",
    title: "What's happening at Mara",
    lead: "Flea markets, auctions, offers and news from our café & showroom in Basel.",
    all: "All",
    upcoming: "Current",
    archive: "Archive",
    readMore: "Read more",
    back: "Back to overview",
    empty: "There are no posts here at the moment. Please check back soon.",
    when: "When",
    where: "Where",
    archived: "Past",
    detailBack: "All posts",
  },
  it: {
    navLabel: "Novità",
    eyebrow: "Eventi & Novità",
    title: "Cosa succede da Mara",
    lead: "Mercatini, aste, promozioni e novità dal nostro caffè e spazio espositivo a Basilea.",
    all: "Tutti",
    upcoming: "Attuali",
    archive: "Archivio",
    readMore: "Scopri di più",
    back: "Torna alla panoramica",
    empty: "Al momento non ci sono contenuti. Torna presto a trovarci.",
    when: "Quando",
    where: "Dove",
    archived: "Passato",
    detailBack: "Tutti i contenuti",
  },
  fr: {
    navLabel: "Actualités",
    eyebrow: "Événements & Actualités",
    title: "Ce qui se passe chez Mara",
    lead: "Brocantes, enchères, offres et actualités de notre café et espace d'exposition à Bâle.",
    all: "Tous",
    upcoming: "Actuels",
    archive: "Archives",
    readMore: "En savoir plus",
    back: "Retour à l'aperçu",
    empty: "Il n'y a aucun contenu pour le moment. Revenez bientôt.",
    when: "Quand",
    where: "Où",
    archived: "Passé",
    detailBack: "Tous les contenus",
  },
  pt: {
    navLabel: "Novidades",
    eyebrow: "Eventos & Novidades",
    title: "O que acontece na Mara",
    lead: "Feiras, leilões, promoções e novidades do nosso café e espaço de exposição em Basileia.",
    all: "Todos",
    upcoming: "Atuais",
    archive: "Arquivo",
    readMore: "Saber mais",
    back: "Voltar à visão geral",
    empty: "De momento não há conteúdos aqui. Volte em breve.",
    when: "Quando",
    where: "Onde",
    archived: "Passado",
    detailBack: "Todos os conteúdos",
  },
};

// Translations for the default (German) category names. New CMS categories fall back to their stored name.
export const categoryLabels = {
  Veranstaltungen: { de: "Veranstaltungen", en: "Events", it: "Eventi", fr: "Événements", pt: "Eventos" },
  Versteigerungen: { de: "Versteigerungen", en: "Auctions", it: "Aste", fr: "Enchères", pt: "Leilões" },
  Aktionen: { de: "Aktionen", en: "Offers", it: "Promozioni", fr: "Offres", pt: "Promoções" },
  Mitteilungen: { de: "Mitteilungen", en: "Announcements", it: "Comunicazioni", fr: "Annonces", pt: "Comunicados" },
  Neuigkeiten: { de: "Neuigkeiten", en: "News", it: "Novità", fr: "Nouveautés", pt: "Novidades" },
  Kooperationen: { de: "Kooperationen", en: "Collaborations", it: "Collaborazioni", fr: "Coopérations", pt: "Cooperações" },
};

export const catLabel = (name, lang) => (categoryLabels[name] && categoryLabels[name][lang]) || name;
